import React from 'react';


import photo from '../../data/photo.json'

export const Photo = (props) => {
  const {fn} = props
 // console.log(fn)

  const [data, setData] = React.useState([])
  const [modal, setModal] = React.useState(false)
  const [modalFull, setModalFull] = React.useState(false)

  const isMobile = window.innerWidth <= 478 ? true : false

  React.useEffect(() => {
      setData(photo.data)
  },[])

  const open = (ind) => {
      
      let i = data.filter(e => e.id === ind)
      setModal(i)

  }



  

  const list3 = () => {
    // console.log('data =>',photo)
    let row1 = []
    let row2 = []
    let row3 = []


    data.map((el, ind) => {
    if(ind % 3 === 0){
      row1.push(
        <div  onClick={() => open(el.id)} key={ind}>
          <img src={el.path} />
          <div className="prev">
          {el.name}
          </div>
        </div>
      )
    }

    else if(ind % 3 === 1 || ind === 86){
      row2.push(
        <div key={ind} onClick={() => open(el.id)}>
          <img src={el.path} />
          <div className="prev">
          {el.name}
          </div>
        </div>
      )
    }

    else if(ind % 3 === 2 && ind !== 86){
      row3.push(
        <div key={ind} onClick={() => open(el.id)}>
          <img src={el.path} />
          <div className="prev">
          {el.name}
          </div>
        </div>
      )
    }

  })
    return (
    <>
    <div>{row1}</div>
    <div>{row2}</div>
    <div>{row3}</div>
    </>
    )
  }

  const list2 = () => {
    // console.log('data =>',photo)
    let row1 = []
    let row2 = []
    let row3 = []


    data.map((el, ind) => {
    if(ind % 2){
      row1.push(
        <div  onClick={() => open(el.id)} key={ind}>
          <img src={el.path} />
          <div className="prev">
          {el.name}
          </div>
        </div>
      )
    }

    else {
      row2.push(
        <div key={ind} onClick={() => open(el.id)}>
          <img src={el.path} />
          <div className="prev">
          {el.name}
          </div>
        </div>
      )
    }

    
    

  })
    return (
    <>
    <div>{row1}</div>
    <div>{row2}</div>
    
    </>
    )
  }

 // console.log(data)
  // console.log(modal[0])

  const control_btm = (ind, way) => {
    let i = data.filter(e => e.id === ind)
   // console.log(i.length > 0 )
    return i.length > 0 ? <span onClick={() => open(ind)} className={way}>{way === 'prv' ? '<' : '>'}</span> : ''
  }

  const _ModalFull = (val) => {
    setModalFull(val)
    fn(val)
  }

  return (
    <>
      {data.length > 0  ? (isMobile ? list2() : list3()) : 'loading...'}
     {modal && <div className="modal__photo">
       <div className="close" onClick={() => setModal(false)}></div>
       <div className="modal_photo__wrapper">
         {modal && (
           <>
           <img src={modal[0]?.path} onClick={() => _ModalFull(true)} />
           <div className="gallery_control">
           {control_btm(modal[0].id - 1, 'prv')}
           <span >{modal[0]?.name}</span>
           {control_btm(modal[0].id + 1, 'nxt')}
           </div>
            
           </>
         )}
       </div>
     </div> }

     {modalFull && <div className="modal__photo_full">
       <div className="close" onClick={() => _ModalFull(false)}></div>
       <div className="modal_photo__wrapper">
         {modal && (
           <>
           
           <div className="gallery_control">
           {control_btm(modal[0].id - 1, 'prv')}
           <img src={modal[0]?.path} />
           {control_btm(modal[0].id + 1, 'nxt')}
           </div>
            
           </>
         )}
       </div>
     </div> }
      


    </>
  );
}

export default Photo;
